module.exports = __webpack_public_path__ + "static/media/carousel3.c1e90b01.jpeg";